import React from 'react';
import Dentist from '../../../components/Dentist/Dentist';
import Feature from '../../../components/Feature/Feature';
import Service from '../../../components/Service/Service';
import About from '../About/About';
import Promo from '../Appoinment-promo/Promo';
import Appoinment from '../Appoinment/Appoinment';
import Banner from '../Banner/Banner';
import Gallery from '../Gallery/Gallery';
import Testimonial from '../Testimonials/testimonial';
const Home = () => {

    return (
        <>
           <Banner />
           <Feature />
           <About />
           <Service />
           <Dentist />
           <Gallery />
           <Testimonial />
           <Promo />
           <Appoinment />
        </>
    );
};

export default Home;